"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetStudyCrfResponse = exports.UpdateStudyCrfResponse = exports.CreateStudyCrfResponse = void 0;
class CreateStudyCrfResponse {
}
exports.CreateStudyCrfResponse = CreateStudyCrfResponse;
class UpdateStudyCrfResponse {
}
exports.UpdateStudyCrfResponse = UpdateStudyCrfResponse;
class GetStudyCrfResponse {
}
exports.GetStudyCrfResponse = GetStudyCrfResponse;
//# sourceMappingURL=studyCrf.js.map